export const ENV = process.env.REACT_APP_ENV;
export const API_URL = process.env.REACT_APP_API_URL;
export const DEFAULT_STRIPE_PK = process.env.REACT_APP_STRIPE_PK;
export const DEFAULT_STRIPE_NAME = process.env.REACT_APP_STRIPE_NAME;
export const AMPLITUDE_KEY = process.env.REACT_APP_AMPLITUDE_KEY;
export const GISMART_KEY = process.env.REACT_APP_GISMART_KEY;
export const LOCKER_STUDIO_DOMAIN = process.env.REACT_APP_LOCKER_STUDIO_DOMAIN;
export const FB_PIXEL_ID = process.env.REACT_APP_FB_PIXEL_ID;
export const ENABLE_PAYPAL = process.env.REACT_APP_ENABLE_PAYPAL;
export const ENABLE_GOOGLE_ANALYTICS_EVENTS = process.env.REACT_APP_ENABLE_GOOGLE_ANALYTICS_EVENTS;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
export const GOOGLE_MEASUREMENT_ID = process.env.REACT_APP_GOOGLE_MEASUREMENT_ID;
export const GTM_ID = process.env.REACT_APP_GTM_ID;
export const GTM_GTG_ID = process.env.REACT_APP_GTM_GTG_ID;
export const GOOGLE_ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;
export const GOOGLE_ADS_LTV_ID_1 = process.env.REACT_APP_GOOGLE_ADS_LTV_ID_1;
export const GOOGLE_ADS_LTV_ID_2 = process.env.REACT_APP_GOOGLE_ADS_LTV_ID_2;
export const GOOGLE_ADS_LTV_ID_3 = process.env.REACT_APP_GOOGLE_ADS_LTV_ID_3;
export const GOOGLE_ADS_LTV_ID_4 = process.env.REACT_APP_GOOGLE_ADS_LTV_ID_4;
export const GOOGLE_ADS_LTV_ID_5 = process.env.REACT_APP_GOOGLE_ADS_LTV_ID_5;
export const GOOGLE_ADS_LTV_ID_6 = process.env.REACT_APP_GOOGLE_ADS_LTV_ID_6;
export const GOOGLE_ADS_LTV_ID_7 = process.env.REACT_APP_GOOGLE_ADS_LTV_ID_7;
export const GOOGLE_ADS_SGTM_ID = process.env.REACT_APP_GOOGLE_ADS_SGTM_ID;
export const GOOGLE_ADS_REVIEW_ID = process.env.REACT_APP_GOOGLE_ADS_REVIEW_ID;
export const GOOGLE_PAY_MERCHANT_ID = process.env.REACT_APP_GOOGLE_PAY_MERCHANT_ID;
export const TIKTOK_PIXEL_ID = process.env.REACT_APP_TIKTOK_ID;
export const OPENAI_PIXEL_ID = process.env.REACT_APP_OPENAI_PIXEL_ID;
export const HOTJAR_ID = process.env.REACT_APP_HOTJAR_ID;
export const CROWDIN_DIST = process.env.REACT_APP_CROWDIN_DIST_HASH;

export const IS_DEV = ENV === 'development';
export const IS_STAGE = ENV === 'stage';
export const IS_PROD = ENV === 'production';
